export default function TiktokMobileFourth() {
    const countryList = [
        {
            en: "AE",
            zh: "阿联酋",
        },
        {
            en: "AU",
            zh: "澳大利亚",
        },
        {
            en: "BR",
            zh: "巴西",
        },
        {
            en: "CA",
            zh: "加拿大",
        },
        {
            en: "CN",
            zh: "中国",
        },
        {
            en: "DE",
            zh: "德国",
        },
        {
            en: "FR",
            zh: "法国",
        },
        {
            en: "HK",
            zh: "香港",
        },
        {
            en: "ID",
            zh: "印度尼西亚",
        },
        {
            en: "IN",
            zh: "印度",
        },
        {
            en: "JP",
            zh: "日本",
        },
        {
            en: "KR",
            zh: "韩国",
        },
        {
            en: "MY",
            zh: "马来西亚",
        },
        {
            en: "PH",
            zh: "菲律宾",
        },
        {
            en: "RU",
            zh: "俄罗斯",
        },
        {
            en: "SE",
            zh: "瑞典",
        },
        {
            en: "SG",
            zh: "新加坡",
        },
        {
            en: "TH",
            zh: "泰国",
        },
        {
            en: "TW",
            zh: "台湾",
        },
        {
            en: "UK",
            zh: "英国",
        },
        {
            en: "US",
            zh: "美国",
        },
        {
            en: "VN",
            zh: "越南",
        },
    ];
    return (
        <div className="pt-[20px] [background:linear-gradient(180deg,rgba(255,255,255,1)_0%,rgba(247.94,246.21,255,1)_34.135%,rgba(232.12,243.25,255,1)_66.346%,rgba(255,255,255,1)_100%)]">
            <div className="flex justify-center"><div className="text-[22px] font-bold text-[rgba(51,51,51,1)]">TikTok可购买的区域</div></div>
            <div className="grid grid-cols-3 gap-[15px] mb-10 px-[20px] mt-[20px]">
                {countryList.map((item) => (
                    <div
                        key={item.en}
                        className="w-[91px] h-[32px] px-[9px] py-[6px] bg-white rounded-[5px] shadow-[0px_4px_30px_0px_rgba(0,0,0,0.08)] inline-flex justify-start items-center gap-[5px]"
                    >
                        <img
                            className="w-[20px] h-[20px]"
                            src={`/imgs/country/${item.en}.webp`}
                            alt={item.zh}
                        />
                        <div className=" inline-flex flex-col justify-start items-start gap-[3px]">
                            <div className="justify-start text-zinc-800 text-[10px] font-medium font-['Alibaba_PuHuiTi_3.0']">
                                {item.zh}
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    )
}